import type { ProjectMethodologyEnum } from 'gql/graphql';
import { Loader } from 'uikit';

import type { FC } from 'react';

import { CatalogPageLayout } from '../CatalogPageLayout';

type TCatalogTablePageProps = {
    catalogName: string | undefined;
    methodology: ProjectMethodologyEnum | ProjectMethodologyEnum[];
    isLoading?: boolean;
    isError?: boolean;
};

export const CatalogTablePage: FC<TCatalogTablePageProps> = (props) => {
    const { catalogName = '', isError, isLoading, methodology, children } = props;

    return (
        <>
            {!isLoading && !isError && (
                <CatalogPageLayout title={catalogName} methodology={methodology}>
                    {children}
                </CatalogPageLayout>
            )}
            {isLoading && <Loader />}
        </>
    );
};

CatalogTablePage.displayName = 'CatalogTablePage';
